import { CheckCircle2, Compass, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import ServiceAreaMap from "@/components/ServiceAreaMap";

export function ServiceAreaCard({
  zip,
  radius,
  onZipChange,
  onRadiusChange,
  onSubmit,
  savingArea,
  serviceAreaComplete,
}) {
  return (
    <div className="card-surface rounded-sm p-6" data-testid="service-area-card" id="service-area">
      <div className="flex items-center gap-2 mb-4">
        <Compass className="w-4 h-4 text-[#6B0F1A]" strokeWidth={1.75} />
        <h3 className="font-display text-lg font-bold text-[#1A0F0A]">Service Area</h3>
        {serviceAreaComplete && (
          <span className="ml-auto"><CheckCircle2 className="w-4 h-4 text-[#6B0F1A]" strokeWidth={1.75} /></span>
        )}
      </div>
      <p className="text-xs text-[#78584B] leading-relaxed mb-5">
        Tell us your home ZIP and how far you'll drive to shoot residential listings.
        This powers your property shoot assignments.
      </p>
      <form onSubmit={onSubmit} className="space-y-4" data-testid="service-area-form">
        <div>
          <label className="font-mono-tag text-[10px] text-[#78584B] block mb-1.5" htmlFor="zip">Base ZIP</label>
          <div className="relative">
            <MapPin className="w-4 h-4 text-[#78584B] absolute left-3.5 top-1/2 -translate-y-1/2" strokeWidth={1.75} />
            <Input
              id="zip"
              data-testid="service-area-zip-input"
              placeholder="10001"
              value={zip}
              onChange={(e) => onZipChange(e.target.value)}
              required
              inputMode="numeric"
              className="pl-10 bg-white border-[#1A0F0A]/15 focus-visible:border-[#6B0F1A] focus-visible:ring-[#6B0F1A]/25 rounded-sm text-[#1A0F0A] placeholder:text-[#A89684]"
            />
          </div>
        </div>
        <div>
          <label className="font-mono-tag text-[10px] text-[#78584B] block mb-1.5" htmlFor="radius">Driving Radius (Miles)</label>
          <Input
            id="radius"
            data-testid="service-area-radius-input"
            placeholder="100"
            type="number"
            min={1}
            max={500}
            value={radius}
            onChange={(e) => onRadiusChange(e.target.value)}
            required
            className="bg-white border-[#1A0F0A]/15 focus-visible:border-[#6B0F1A] focus-visible:ring-[#6B0F1A]/25 rounded-sm text-[#1A0F0A] placeholder:text-[#A89684]"
          />
        </div>
        <Button
          type="submit"
          data-testid="service-area-save-btn"
          disabled={savingArea}
          className="w-full bg-[#6B0F1A] hover:bg-[#8A1424] text-[#F5EBD9] font-bold text-xs tracking-wide rounded-sm btn-primary-glow"
        >
          {savingArea ? "Saving…" : serviceAreaComplete ? "Update service area" : "Save service area"}
        </Button>
      </form>
      <ServiceAreaMap zip={zip} radiusMiles={radius} />
    </div>
  );
}
